import { Component, Input, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "card-button",
  templateUrl: "./card-button.component.html",
  styleUrls: ["./card-button.component.scss"],
})
export class CardButtonComponent implements OnInit {
  @Input() label: string = "";
  @Input() image: string = "";
  @Input() link: string | undefined = "";
  constructor(private router: Router) {}

  ngOnInit(): void {}

  redirect(event: MouseEvent) {
    event.stopImmediatePropagation();
    if (this.link) {
      this.router.navigate([this.link]);
    }
  }
}
